

const PV = document.cookie.replace(/^.*PV=([\d\.]+)(?=;|\b).*$/, '$1') || "";
/**
 * 灵犀事件埋点 lxBidTracker
 * @param {Object} opts {bid: String | 必传, type: String | 埋点类型,默认'moduleClick', customParam: Object | 业务参数}
 */
export const lxBidTracker = function (opts = {}, hotelId = '', userId = ''){
  let bid = opts.bid;
  if (!bid || bid === "") {
    console.error('bid is necessary！');
    return;
  }
  let type = opts.type || 'moduleClick';
  let customParam = opts.customParam || {};
  let custom = {
    AppVersion: PV,
    hotel_id: hotelId,
    user_id: userId,
    agency_id: "",
    ...customParam
  };
  let valLab = {
    custom: custom
  };
  window.LXAnalytics && window.LXAnalytics(type, bid, valLab);
};

/**
 * 灵犀页面埋点 lxCidTracker
 * @param {String} path 需要埋点的路由，获取cid
 */
export const lxCidTracker = function (path, hotelId = '', userId = ''){
  let cid = path.meta && path.meta.cid;
  let valLab = {};
  if (cid) {
    valLab = {
      custom: {
        "AppVersion": PV,
        "hotel_id": hotelId,
        "user_id": userId,
        "agency_id": ""
      }
    };
    window.LXAnalytics && window.LXAnalytics('pageView', valLab, {}, cid);
  }
};



// WEBPACK FOOTER //
// ./src/utils/lxTracker.js